import {
  VN_CARD_READER_ERROR,
  VN_DEBUGGER_ENABLED,
  VN_DEBUGGER_PASSTHROUGH_ENABLED,
  VN_DEBUGGER_PASSTHROUGH_MESSAGE,
  VN_SIMULATED_DISCONNECTION,
} from './ActionTypes'

export function setSimulateDisconnect(data) {
  return (dispatch) => {
    dispatch({
      type: VN_SIMULATED_DISCONNECTION,
      data,
    })
  }
}

export function setVNDebuggerEnabled(data) {
  return (dispatch) => {
    dispatch({
      type: VN_DEBUGGER_ENABLED,
      data,
    })
  }
}

export function setCardReaderError(data) {
  return (dispatch) => {
    dispatch({
      type: VN_CARD_READER_ERROR,
      data,
    })
  }
}

export function setDebuggerPassthroughEnabled(data) {
  return (dispatch) => {
    dispatch({
      type: VN_DEBUGGER_PASSTHROUGH_ENABLED,
      data,
    })
  }
}

export function setDebuggerPassthroughMessage(data) {
  return (dispatch) => {
    dispatch({
      type: VN_DEBUGGER_PASSTHROUGH_MESSAGE,
      data,
    })
  }
}
